export const planTypes = {
  AllPlans: "AllPlans",
  MyPlans: "MyPlans",
  MulipleAssign: "Mulitple Assign"
};

export const responseTypes = {
  success: 200,
  created: 201,
  accepted: 202,
  no_content: 204,
  partial_content: 206,
  deleted: 207,
  error: 400,
  unauthorized: 401,
  forbidden: 403,
  not_found: 404,
  internal_error: 500,
  other_error: 600
};

export const responseStatusTypes = {
  error: "error",
  success: "success",
  warning: "warning"
};

export const formTypes = {
  CreatePlan: "Create",
  EditPlan: "Edit"
};

export const pageNames = {
  libraryHall: 0,
  allPlans: 1,
  bookmarked: 2,
  suggested: 3,
  myPlans: 4,
  noActivePlans: 5,
  noAssignAction: 6,
  noReports: 7,
  noSuggestedFilter: 8,
  functionalArea: 9,
  searchResult: 10,
  searchResultAction: 11,
  globalSearchResult: 12,
  innCodePlans: 13,
  aboveProperty: 14,
  abovePropertyPlans: 15
};

export const serviceTypes = {
  recommendation: "recommendation",
  userplan: "userplan",
  user: "user",
  notification: "notification",
  library: "library"
};

export const engagementTypes = {
  active: "Active",
  overdue: "Overdue",
  inactive: "Inactive"
};
export const leftNavItems = {
  dashboard: "Dashboard",
  myDashboard: "My Dashboard",
  impersonateUser: "Impersonate User",
  library: "Library",
  inncodePlans: "Inncode Plans",
  myPlans: "My Plans",
  uploadFile: "Upload File"
};

export const userTypes = {
  ADMIN: "admin",
  SME: "sme",
  OTHER: "other"
};
